import { FORM_VALIDATOR_TYPES } from '../constants';
import { SyllabusFormValues } from '../interface/syllabus.interface';

export enum FREQUENCY_TYPE {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI = 'SEMI',
  ANNUAL = 'ANNUAL',
}

export enum SYLLABUS_STATUS {
  DELETED = 'DELETED',
}

/**
 * Raw frequency values only — labels are resolved at render time against the
 * `frequency.*` catalog via useTranslatedOptions(). Building the labels here
 * would freeze them in whichever language was active at import.
 */
export const SYLLABUS_TYPE_VALUES = [
  FREQUENCY_TYPE.DAILY,
  FREQUENCY_TYPE.WEEKLY,
  FREQUENCY_TYPE.MONTHLY,
  FREQUENCY_TYPE.QUARTERLY,
  FREQUENCY_TYPE.SEMI,
  FREQUENCY_TYPE.ANNUAL,
] as const;

export const SYLLABUS_FORM_INIT: SyllabusFormValues = {
  curriculum: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  grade: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  subject: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  description: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  type: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
};
